<template>
  <div id="left-side">
    <el-menu
      class="el-menu-vertical-demo"
      :background-color="settings.sidebarColor"
      text-color="#fff"
      active-text-color="#10b20a"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      :collapse="isCollapse"
    >
      <el-menu-item index="/admin/setting">
        <!--<i v-popover:usercard>-->
        <img
          :src="userInfo.avatar"
          width="40px"
          height="40px"
          style="margin-left: -8px;"
        />
        <span
          style="height: 10px; width: 10px; background-color: red; position: absolute; bottom: 5px; right: 5px;"
        ></span>
        <!--</i>-->
        <span slot="title" style="margin-left: 5px;">{{ userInfo.nickname }}</span>
      </el-menu-item>
      <el-menu-item index="/admin/chat">
        <el-badge
          v-if="totalUnreadCount > 0"
          :value="totalUnreadCount"
          :max="99"
          class="item"
        >
          <i class="iconfont icon-chat"></i>
        </el-badge>
        <i v-if="totalUnreadCount === 0" class="iconfont icon-chat"></i>
        <!-- <i class="el-icon-chat-round"></i> -->
        <span slot="title" style="margin-left: 5px;">{{ $t("threads") }}</span>
        <!-- <span>123</span> -->
      </el-menu-item>
      <el-menu-item index="/admin/contact">
        <i class="iconfont icon-group"></i>
        <span slot="title" style="margin-left: 5px;">{{ $t("contacts") }}</span>
      </el-menu-item>
      <el-menu-item index="/admin/queue">
        <el-badge
          v-if="userQueuesCount > 0"
          :value="userQueuesCount"
          :max="99"
          class="item"
        >
          <i class="iconfont icon-pdydios"></i>
        </el-badge>
        <i v-if="userQueuesCount === 0" class="iconfont icon-pdydios"></i>
        <span slot="title" style="margin-left: 5px;">{{ $t("queues") }}</span>
      </el-menu-item>
      <el-menu-item index="/admin/online">
        <i class="iconfont icon-footprint"></i>
        <span slot="title" style="margin-left: 5px;">{{
          $t("onlineVisitors")
        }}</span>
      </el-menu-item>
      <el-menu-item index="/admin/monitor" v-if="isAdmin">
        <i class="iconfont icon-Laptopmonitor"></i>
        <span slot="title" style="margin-left: 5px;">{{ $t("monitors") }}</span>
      </el-menu-item>
      <el-menu-item index="/admin/ticket">
        <el-badge
          v-if="totalTicketUnreadCount > 0"
          :value="totalTicketUnreadCount"
          :max="99"
          class="item"
        >
          <i class="iconfont icon-ticket"></i>
        </el-badge>
        <i v-if="totalTicketUnreadCount === 0" class="iconfont icon-ticket"></i>
        <span slot="title" style="margin-left: 5px;">{{ $t("tickets") }}</span>
      </el-menu-item>
      <el-menu-item index="/admin/kb" v-if="isAdmin">
        <i class="iconfont icon-book" style="font-size: 32px; margin-left: -5px;"></i>
        <span slot="title" style="margin-left: 5px;">{{ $t("kb") }}</span>
      </el-menu-item>
      <el-submenu index="/admin/more">
        <template slot="title">
          <i class="iconfont icon-more"></i>
          <span slot="title" style="margin-left: 5px;">
            {{ $t("moreFunctions") }}</span
          >
        </template>
        <el-menu-item index="/admin/todo">
          <i class="iconfont icon--Todo-List"></i>
          <span slot="title" style="margin-left: 5px;">{{ $t("todos") }}</span>
        </el-menu-item>
        <el-menu-item index="/admin/notice">
          <i class="iconfont icon-notice"></i>
          <span slot="title" style="margin-left: 5px;">{{ $t("notices") }}</span>
        </el-menu-item>
        <el-menu-item index="/admin/block">
          <i class="iconfont icon-block"></i>
          <span slot="title" style="margin-left: 5px;">{{
            $t("blockList")
          }}</span>
        </el-menu-item>
        <!--<el-menu-item index="/admin/statistic" v-if="showAuthority.debug"> {{ $t('statistic') }}</el-menu-item>-->
        <el-menu-item index="/admin/crm">
          <i class="iconfont icon-pdydios"></i>
          <span slot="title" style="margin-left: 5px;">{{ $t("crmAdmin") }}</span>
        </el-menu-item>
        <!-- <el-menu-item index="/admin/weworkinternal" v-if="showAuthority.debug">
          <i class="iconfont icon-pdydios"></i>
          <span slot="title" style="margin-left: 5px;">{{ $t("weworkinternal") }}</span>
        </el-menu-item> -->
        <!-- <el-menu-item index="/admin/weworkthird" v-if="showAuthority.debug">
          <i class="iconfont icon-pdydios"></i>
          <span slot="title" style="margin-left: 5px;">{{ $t("weworkthird") }}</span>
        </el-menu-item> -->
        <el-menu-item index="/admin/custom" v-if="showAuthority.debug">
          <i class="iconfont icon-pdydios"></i>
          <span slot="title" style="margin-left: 5px;">{{ $t("custom") }}</span>
        </el-menu-item>
        <el-menu-item index="/admin/form" v-if="showAuthority.debug">
          {{ $t("form") }}</el-menu-item>
        <el-menu-item index="/admin/robot" v-if="showAuthority.debug">
          {{ $t("robot") }}</el-menu-item>
        <el-menu-item index="/admin/weiyuai" v-if="showAuthority.debug">
          {{ $t("weiyuai") }}</el-menu-item>
        <!--<el-menu-item index="/admin/leavemsg"> {{ $t('leavemsgAdmin') }}</el-menu-item>
        <el-menu-item index="/admin/thread"> {{ $t('threadAdmin') }}</el-menu-item>
        <el-menu-item index="/admin/message"> {{ $t('messageAdmin') }}</el-menu-item>
        <el-menu-item index="/admin/summary"> {{ $t('summaryAdmin') }}</el-menu-item>
        <el-menu-item index="/admin/feedback"> {{ $t('feedback') }}</el-menu-item>
        <el-menu-item index="/admin/statuses"> {{ $t('statusAdmin') }}</el-menu-item>-->
        <!--<el-menu-item index="/admin/tag" v-if="showAuthority.debug"> {{ $t('tagAdmin') }}</el-menu-item>-->
        <el-menu-item index="/admin/quality" v-if="showAuthority.debug"> {{ $t('quality') }}</el-menu-item>
        <!--<el-menu-item index="/admin/rate"> {{ $t('rate') }}</el-menu-item>-->
        <!--<el-menu-item index="/admin/cuw" v-if="showAuthority.debug"> {{ $t('cuw') }}</el-menu-item>-->
        <!--<el-menu-item index="/admin/keyword" v-if="showAuthority.debug"> {{ $t('keywordAdmin') }}</el-menu-item>-->
      </el-submenu>
      <!-- TODO: 放到管理后台，暂不放客服对话后台 -->
      <!-- <el-menu-item index="/admin/summary" v-if="showAuthority.debug">
        <i class="iconfont icon-notice"></i>
        <span slot="title" style="margin-left: 5px;">小结</span>
      </el-menu-item> -->
      <!-- TODO: 支持插件，类似vscode -->
      <!-- <el-menu-item index="/admin/favorite">
        <i class="iconfont icon-favorite"></i>
        <span slot="title" style="margin-left: 5px;">我的收藏</span>
      </el-menu-item> -->
      <!-- TODO: 客服模块作为插件存在 -->
      <el-submenu index="" class="bd-more">
        <template slot="title">
          <i class="iconfont icon-moreclass"></i>
          <span slot="title">{{ $t("more") }}</span>
        </template>
        <el-menu-item index="/admin/status">
          <i v-if="connecting" class="el-icon-loading"></i>
          <i v-if="connected" class="el-icon-check"></i>
          <i v-if="disconnected" class="el-icon-close"></i>
          <span v-if="connecting" style="margin-left: 5px;">
            {{ $t("connecting") }}...</span
          >
          <span v-if="connected" style="margin-left: 5px;">
            {{ $t("connected") }}</span
          >
          <span v-if="disconnected" style="margin-left: 5px;">
            {{ $t("disconnected") }}</span
          >
        </el-menu-item>
        <!-- 设置接待状态 -->
        <el-submenu index="/admin/accept">
          <template slot="title">
            <i class="el-icon-chat-round"></i>
            <span slot="title" style="margin-left: 5px;">
              {{ onlineStatus }}</span
            >
          </template>
          <!-- 正常接待 -->
          <el-menu-item index="/admin/accept/online">
            <i class="el-icon-chat-round"></i>
            {{ $t("online") }}
          </el-menu-item>
          <!-- 已经接入的正常对话，不再分配新会话 -->
          <el-menu-item index="/admin/accept/busy">
            <i class="el-icon-time"></i>
            {{ $t("busy") }}
          </el-menu-item>
          <!-- 相当于下线，不再接收新消息，同时也不再分配新会话 -->
          <el-menu-item index="/admin/accept/rest">
            <i class="el-icon-moon"></i>
            {{ $t("rest") }}
          </el-menu-item>
        </el-submenu>
        <!-- 设置视频客服接待状态 -->
        <el-submenu index="/admin/webrtc">
          <template slot="title">
            <i class="el-icon-video-camera"></i>
            <span slot="title" style="margin-left: 5px;">
              {{ webrtcStatus2 }}</span
            >
          </template>
          <!-- 正常接待 -->
          <el-menu-item index="/admin/webrtc/online">
            <i class="el-icon-video-camera"></i>
            {{ $t("webrtcOnline") }}
          </el-menu-item>
          <!-- 已经接入的正常对话，不再分配新会话 -->
          <el-menu-item index="/admin/webrtc/busy">
            <i class="el-icon-time"></i>
            {{ $t("webrtcBusy") }}
          </el-menu-item>
          <!-- 相当于下线，不再接收新消息，同时也不再分配新会话 -->
          <el-menu-item index="/admin/webrtc/rest">
            <i class="el-icon-moon"></i>
            {{ $t("webrtcRest") }}
          </el-menu-item>
        </el-submenu>
        <!-- 设置自动回复 -->
        <el-submenu index="/admin/autoreply">
          <template slot="title">
            <i class="el-icon-message"></i>
            <span slot="title" style="margin-left: 5px;">
              {{ showAutoReplyContent() }}</span
            >
          </template>
          <el-menu-item index="/admin/autoreply/noreply">{{
            autoReplyNoTip
          }}</el-menu-item>
          <el-menu-item index="/admin/autoreply/eat">{{
            autoReplyEatTip
          }}</el-menu-item>
          <el-menu-item index="/admin/autoreply/leave">{{
            autoReplyLeaveTip
          }}</el-menu-item>
          <el-menu-item index="/admin/autoreply/back">{{
            autoReplyBackTip
          }}</el-menu-item>
          <el-menu-item index="/admin/autoreply/phone">{{
            autoReplyPhoneTip
          }}</el-menu-item>
          <el-menu-item index="/admin/autoreply/self">{{
            autoReplySelfTip
          }}</el-menu-item>
        </el-submenu>
        <el-submenu index="/admin/help">
          <template slot="title">
            <i class="el-icon-help"></i>
            <span slot="title" style="margin-left: 5px;">
              {{ $t("helpCenter") }}</span
            >
          </template>
          <el-menu-item index="/admin/help/center">{{
            $t("helpCenter")
          }}</el-menu-item>
          <!-- <el-menu-item index="/admin/help/feedback">意见反馈</el-menu-item> -->
          <!-- <el-menu-item index="/admin/help/ticket">提交工单</el-menu-item> -->
          <el-menu-item index="/admin/help/chat">{{
            $t("contactAgent")
          }}</el-menu-item>
        </el-submenu>
        <el-submenu index="/admin/lang">
          <template slot="title">
            <i class="el-icon-location-outline"></i>
            <span slot="title" style="margin-left: 5px;">
              {{ $t("language") }}</span
            >
          </template>
          <el-menu-item index="/admin/lang/zh">中文</el-menu-item>
          <el-menu-item index="/admin/lang/en">English</el-menu-item>
        </el-submenu>
        <el-menu-item index="/admin/admin">
          <i class="el-icon-s-check"></i>
          <span slot="title" style="margin-left: 5px;"> {{ $t("admin") }}</span>
        </el-menu-item>
        <el-menu-item index="/admin/setting">
          <i class="el-icon-user"></i>
          <span slot="title" style="margin-left: 5px;">
            {{ $t("settings") }}</span
          >
        </el-menu-item>
        <el-menu-item index="/admin/logout">
          <i class="el-icon-switch-button"></i>
          <span slot="title" style="margin-left: 5px;">
            {{ $t("logout") }}</span
          >
        </el-menu-item>
      </el-submenu>
    </el-menu>

    <!-- 用户卡片 -->
    <el-popover
      ref="usercard"
      trigger="hover"
      placement="right-start"
      popper-class="no-padding"
      :visible-arrow="false"
    >
      <AccountCard />
    </el-popover>

    <el-dialog
      v-dialogDrag
      :title="selfDefineTip"
      :visible.sync="autoReplyDialogVisible"
      width="30%"
      center
    >
      <p style="font-size: 8px;">
        {{ $t("pleaseInputAutoReplyContent") }}({{ $t("cantBeLongerThan250") }})
      </p>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 8 }"
        :placeholder="pleaseInputAutoReplyContentTip"
        v-model="autoReplyContent"
      >
      </el-input>
      <p style="font-size: 8px;">{{ $t("autoReplyTip") }}</p>
      <el-input
        :placeholder="pleaseInputAutoReplyImageTip"
        v-model="autoReplyImageUrl"
      ></el-input>
      <p></p>
      <img
        v-if="showAutoReplyImage"
        :src="autoReplyImageUrl"
        width="40px"
        height="40px"
        style="float: left; margin-right: 15px;"
      />
      <i
        v-if="showAutoReplyImage"
        @click="removeAutoReplyImage"
        class="el-icon-close"
      ></i>
      <el-upload
        class="upload-demo"
        :data="upload_data"
        :name="upload_name"
        :action="uploadImageServerUrl"
        :on-success="handleImageUploadSuccess"
        :before-upload="beforeImageUpload"
      >
        <el-button size="small" type="primary">{{ uploadTip }}</el-button>
      </el-upload>
      <br />
      <el-button @click="handleDrawerOpen" size="small">{{
        autoReplyHistoryTip
      }}</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="autoReplyDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="doSelfAutoReply">{{
          $t("save")
        }}</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :title="autoReplyHistoryTip"
      :visible.sync="showDrawer"
      :direction="drawerDirection"
      :before-close="handleDrawerClose"
    >
      <el-table :data="autoReplyList" border style="width: 100%">
        <el-table-column prop="content" label="内容" width="150">
        </el-table-column>
        <el-table-column prop="imageUrl" label="图片"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="handleViewAutoReplyImageClick(scope.row)"
              type="text"
              size="small"
              >{{ $t("viewImage") }}
            </el-button>
            <el-button
              @click="handleUseAutoReplyClick(scope.row)"
              type="text"
              size="small"
              >{{ $t("use") }}</el-button
            >
            <el-button
              @click="handleDeleteAutoReplyClick(scope.row)"
              type="text"
              size="small"
              >{{ $t("delete") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import bus from "@/util/eventbus";
import Vue from "vue";
const constants = require("@/util/constants");
import AccountCard from "@/components/dashboard/setting/AccountCard";

export default {
  name: "bd-aside",
  components: {
    AccountCard,
  },
  data() {
    return {
      isCollapse: true,
      currentKey: "/admin/chat",
      showSupport: constants.SHOW_SUPPORT,
      //
      autoReplyContent: constants.AUTO_REPLY_NO,
      autoReplyImageUrl: "",
      // autoReplyNo: constants.AUTO_REPLY_NO,
      // autoReplyEat: constants.AUTO_REPLY_EAT,
      // autoReplyLeave: constants.AUTO_REPLY_LEAVE,
      // autoReplyBack: constants.AUTO_REPLY_BACK,
      // autoReplyPhone: constants.AUTO_REPLY_PHONE,
      // autoReplySelf: constants.AUTO_REPLY_SELF,
      autoReplyDialogVisible: false,
      // autoReplySelfContent: '',
      //
      homeUrl: constants.HOME_URL,
      chatUrl: constants.CHAT_URL,
      adminUrl: constants.ADMIN_URL,
      helpUrl: constants.HELP_URL,
      electron: constants.IS_ELECTRON,
      //
      // 上传图片相关参数
      upload_headers: {
        "X-CSRF-TOKEN": "",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        Authorization: "Bearer ",
      },
      upload_data: {
        file_name: "test.png",
        username: "",
      },
      upload_name: "file",
      uploadImageServerUrl: constants.UPLOAD_IMAGE_URL,
      // langs: ['zh', 'en', 'jp']
      showDrawer: false,
      drawerDirection: "rtl",
      // autoReplyHistoryData: []
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "autoReplyList",
      "userThreads",
      "isAdmin",
      "status",
      "webrtcStatus",
      "connectionStatus",
      "showAuthority",
      "settings",
      "totalUnreadCount",
      "userQueuesCount",
      "totalTicketUnreadCount"
    ]),
    currentYear() {
      return new Date().getFullYear();
    },
    //
    autoReplyNoTip() {
      return this.$t("autoReplyNo");
    },
    autoReplyEatTip() {
      return this.$t("autoReplyEat");
    },
    autoReplyLeaveTip() {
      return this.$t("autoReplyLeave");
    },
    autoReplyBackTip() {
      return this.$t("autoReplyBack");
    },
    autoReplyPhoneTip() {
      return this.$t("autoReplyPhone");
    },
    autoReplySelfTip() {
      return this.$t("autoReplySelf");
    },
    uploadTip() {
      return this.$t("uploadImage");
    },
    autoReplyHistoryTip() {
      return this.$t("autoReplyHistory");
    },
    showAutoReplyImage() {
      return (
        this.autoReplyImageUrl != "" &&
        this.autoReplyImageUrl != null &&
        this.autoReplyImageUrl != undefined
      );
    },
    //
    connecting() {
      return (
        this.connectionStatus === constants.STOMP_CONNECTION_STATUS_CONNECTING
      );
    },
    connected() {
      return (
        this.connectionStatus === constants.STOMP_CONNECTION_STATUS_CONNECTED
      );
    },
    disconnected() {
      return (
        this.connectionStatus === constants.STOMP_CONNECTION_STATUS_DISCONNECTED
      );
    },
    connectingImage() {
      return constants.CONNECTING_IMAGE;
    },
    connectedImage() {
      return constants.CONNCTED_IMAGE;
    },
    disconnectedImage() {
      return constants.DISCONNECTED_IMAGE;
    },
    onlineStatus() {
      if (this.status === constants.USER_STATUS_ONLINE) {
        // return '在线接待'
        return this.$t("online");
      } else if (this.status === constants.USER_STATUS_BUSY) {
        // return '接待忙线'
        return this.$t("busy");
      } else {
        // return '接待小休'
        return this.$t("rest");
      }
    },
    webrtcStatus2() {
      if (this.webrtcStatus === constants.USER_STATUS_ONLINE) {
        return this.$t("webrtcOnline");
      } else if (this.webrtcStatus === constants.USER_STATUS_BUSY) {
        return this.$t("webrtcBusy");
      } else if (this.webrtcStatus === constants.USER_STATUS_REST) {
        return this.$t("webrtcRest");
      } else {
        return "视频客服";
      }
    },
    //
    selfDefineTip() {
      return this.$t("selfDefine");
    },
    pleaseInputAutoReplyContentTip() {
      return this.$t("pleaseInputAutoReplyContent");
    },
    pleaseInputAutoReplyImageTip() {
      return this.$t("pleaseInputAutoReplyImage");
    },
  },
  methods: {
    ...mapActions([
      "setAcceptStatus",
      "setWebrtcStatus",
      "queryAutoReply",
      "updateAutoReply2",
      "deleteAutoReply",
      "logout",
    ]),
    handleImageUploadSuccess(result, file) {
      console.log("upload image success result:", result, " file:", file);
      if (result.status_code === 200) {
        this.autoReplyImageUrl = result.data;
      } else {
        this.$message.error(this.$t("uploadError"));
      }
    },
    beforeImageUpload(file) {
      // console.log('before image upload file:', file)
      const isJPGorPNG =
        file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // 验证图片格式
      if (!isJPGorPNG) {
        this.$message.error(this.$t("uploadFormatError"));
      }
      // 验证图片大小
      if (!isLt2M) {
        this.$message.error(this.$t("uploadSizeError"));
      }
      // 设置文件名
      let filename = moment(new Date()).format("YYYYMMDDHHmmss");
      if (file.type === "image/jpeg") {
        this.upload_data.file_name = filename + ".jpg";
      } else if (file.type === "image/png") {
        this.upload_data.file_name = filename + ".png";
      }
      // 返回
      return isJPGorPNG && isLt2M;
    },
    removeAutoReplyImage() {
      this.autoReplyImageUrl = "";
    },
    handleOpen(key, keyPath) {
      // console.log('open', key, keyPath)
    },
    handleClose(key, keyPath) {
      // console.log('close', key, keyPath)
    },
    onFeedback() {
      this.feedDialogVisible = true;
    },
    showAutoReplyContent() {
      if (this.userInfo.autoReplyContent !== null) {
        return this.userInfo.autoReplyContent.substring(0, 4);
      }
      return this.autoReplyNoTip;
    },
    onChat() {
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.chatUrl);
      } else {
        window.open(this.chatUrl);
      }
    },
    onAdmin() {
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.adminUrl);
      } else {
        window.open(this.adminUrl);
      }
    },
    onHelp() {
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.helpUrl);
      } else {
        window.open(this.helpUrl);
      }
    },
    doUpdateAutoReply(autoReply) {
      let payload = {
        isAutoReply: autoReply,
        content: this.autoReplyContent,
        imageUrl: this.autoReplyImageUrl,
      };
      this.updateAutoReply2(payload);
    },
    doSelfAutoReply() {
      if (this.autoReplyContent.trim().length === 0) {
        this.$message.warning(this.$t("cantBeEmpty"));
        return;
      }
      if (this.autoReplyContent.trim().length > 250) {
        this.$message.warning(this.$t("cantBeLongerThan250"));
        return;
      }
      if (
        this.autoReplyImageUrl.trim().length > 0 &&
        !this.autoReplyImageUrl.startsWith("http")
      ) {
        this.$message.warning(this.$t("imageUrlFormatError"));
        return;
      }
      this.autoReplyDialogVisible = false;
      //
      let payload = {
        isAutoReply: true,
        content: this.autoReplyContent,
        imageUrl: this.autoReplyImageUrl,
      };
      this.updateAutoReply2(payload);
    },
    handleSelect(key, keyPath) {
      // if (this.currentKey === key && !key.startsWith('/admin/autoreply') && !(key === '/admin/logout')) {
      //   return
      // }
      this.currentKey = key;
      // console.log(key, keyPath)
      if (key === "/admin/logout") {
        // TODO: 首先判断是否有进行中客服会话，如果有的话，禁止退出
        this.$confirm(this.$t("wantToLogout"), this.$t("tip"), {
          confirmButtonText: this.$t("ok"),
          cancelButtonText: this.$t("cancel"),
          type: "warning",
        })
          .then(() => {
            this.logout();
          })
          .catch(() => {
            //
          });
      } else if (key === "/admin/status") {
        // TODO: 路由到状态管理？
        console.log("status");
      } else if (key.startsWith("/admin/accept")) {
        // console.log('accept', key)
        if (key === "/admin/accept/online") {
          this.setAcceptStatus(constants.USER_STATUS_ONLINE);
        } else if (key === "/admin/accept/busy") {
          this.setAcceptStatus(constants.USER_STATUS_BUSY);
        } else if (key === "/admin/accept/rest") {
          // 首先判断当前是否有进行中客服会话，如果有，则提示并返回
          if (this.userThreads.length > 0) {
            this.$alert(this.$t("finishOnGoingThreads"), this.$t("tip"), {
              confirmButtonText: this.$t("ok"),
              callback: (action) => {},
            });
            return;
          }
          this.setAcceptStatus(constants.USER_STATUS_REST);
        }
      } else if (key.startsWith("/admin/webrtc")) {
        // console.log('accept', key)
        if (key === "/admin/webrtc/online") {
          this.setWebrtcStatus(constants.USER_STATUS_ONLINE);
        } else if (key === "/admin/webrtc/busy") {
          this.setWebrtcStatus(constants.USER_STATUS_BUSY);
        } else if (key === "/admin/webrtc/rest") {
          this.setWebrtcStatus(constants.USER_STATUS_REST);
        }
      } else if (key.startsWith("/admin/autoreply")) {
        // console.log('autoreply', key)
        if (key === "/admin/autoreply/noreply") {
          this.autoReplyContent = this.autoReplyNoTip;
          this.doUpdateAutoReply(false);
        } else if (key === "/admin/autoreply/eat") {
          this.autoReplyContent = this.autoReplyEatTip;
          this.doUpdateAutoReply(true);
        } else if (key === "/admin/autoreply/leave") {
          this.autoReplyContent = this.autoReplyLeaveTip;
          this.doUpdateAutoReply(true);
        } else if (key === "/admin/autoreply/back") {
          this.autoReplyContent = this.autoReplyBackTip;
          this.doUpdateAutoReply(true);
        } else if (key === "/admin/autoreply/phone") {
          this.autoReplyContent = this.autoReplyPhoneTip;
          this.doUpdateAutoReply(true);
        } else if (key === "/admin/autoreply/self") {
          this.autoReplyContent = this.userInfo.autoReplyContent;
          this.autoReplyImageUrl = this.userInfo.autoReplyImageUrl;
          this.autoReplyDialogVisible = true;
        }
      } else if (key.startsWith("/admin/help/center")) {
        console.log("help center");
        this.onHelp();
      } else if (key.startsWith("/admin/help/feedback")) {
        console.log("help feedback");
      } else if (key.startsWith("/admin/help/ticket")) {
        console.log("help ticket");
      } else if (key.startsWith("/admin/help/chat")) {
        // console.log('help chat')
        this.onChat();
      } else if (key.startsWith("/admin/admin")) {
        // console.log('admin')
        this.onAdmin();
      } else if (key.startsWith("/admin/lang/zh")) {
        // 更改为中文
        this.$i18n.locale = "zh";
        Vue.ls.set(constants.I18N, "zh");
        localStorage.i18n = "zh";
        // TODO: 同步更新title
      } else if (key.startsWith("/admin/lang/en")) {
        // 更改为English
        this.$i18n.locale = "en";
        Vue.ls.set(constants.I18N, "en");
        localStorage.i18n = "en";
        // TODO: 同步更新title
      } else {
        this.$router.replace(key);
      }
    },
    handleDrawerOpen() {
      this.showDrawer = true;
      //
      let payload = { page: 0, size: 20 };
      this.queryAutoReply(payload);
    },
    handleDrawerClose(done) {
      done();
    },
    handleViewAutoReplyImageClick(row) {
      // console.log(row)
      if (row.imageUrl === "" || row.imageUrl === undefined) {
        this.$message.warning(this.$t("imageUrlNull"));
        return;
      }
      if (this.electron) {
        ipcRenderer.send("open-external-url", row.imageUrl);
      } else {
        window.open(row.imageUrl);
      }
    },
    handleUseAutoReplyClick(row) {
      // console.log(row)
      this.autoReplyContent = row.content;
      this.autoReplyImageUrl = row.imageUrl;
      this.showDrawer = false;
    },
    handleDeleteAutoReplyClick(row) {
      // console.log(row);
      let aid = row.aid;
      this.deleteAutoReply(aid);
    },
  },
  created() {},
  mounted() {
    bus.$on("collapse", (collapse) => {
      this.isCollapse = collapse;
    });
  },
};
</script>

<style scoped>
#left-side {
  height: 100%;
  overflow: hidden;
}
.iconfont {
  font-size: 25px;
}
.el-menu-vertical-demo {
  height: 100%;
  padding-top: 40px;
  overflow-y: auto;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-badge__content .is-fixed .is-dot {
  margin-top: 10px;
  margin-right: 40px;
}
.bd-more {
  position: fixed !important;
  bottom: 10px;
  width: 63px;
}
.bd-image {
  float: left;
  height: 15px;
  width: 15px;
}
.auto-reply-content {
  margin-left: 5px;
  width: 150px;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
